import { Text, TextTypes } from 'components'

import React from 'react'
import { StyledButton } from './styled'
import { useStore } from 'services/store'

type ButtonTypes = 'primary' | 'secondary' | 'light-secondary' | 'wallet' | 'warning'

export interface CustomButtonProps {
  buttonType: ButtonTypes
  text?: string
  className?: string
  fontType?: TextTypes
  disabled?: boolean
  textFontSize?: number
  onClick?: () => void
  redirectIcon?: boolean
  icon?: JSX.Element
  isActive?: boolean
  id?: string
}

export type ButtonProps = CustomButtonProps & React.HTMLProps<HTMLButtonElement>

export const Button: React.FC<ButtonProps> = ({
  buttonType,
  children,
  text = '',
  onClick,
  className,
  icon,
  fontType,
  disabled = false,
  isActive,
  id,
}) => {
  const { isDarkMode } = useStore()
  return (
    <StyledButton
      id={id}
      className={className}
      text={text}
      disabled={disabled}
      onClick={onClick}
      buttonType={buttonType}
      isDarkTheme={isDarkMode}
      isActive={isActive}
    >
      <>
        {icon}
        {text ? <Text type={fontType}>{text}</Text> : children}
      </>
    </StyledButton>
  )
}
